// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: Arial, sans-serif;
}

.footer-container {
    background-color: #222222;
    color: #a9a9a9;
    padding: 40px 60px;
    font-size: 14px;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    max-width: 1430px;
    margin: 0 auto;
}

.footer-left {
    display: flex;
    align-items: flex-start;
}

.footer-logo {
    margin-right: 40px;
}

.footer-logo img {
    height: 120px;
}

.footer-company-info .company-name {
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    margin-top: 0;
    margin-bottom: 20px;
}

.footer-company-info p {
    margin: 8px 0;
    line-height: 1.6;
}

.footer-company-info .copyright {
    margin-top: 30px;
    color: #888;
}

.footer-right {
    text-align: left;
}

.footer-links {
    margin-bottom: 20px;
}

.footer-links a {
    color: #fff;
    font-weight: bold;
    text-decoration: none;
    font-size: 16px;
    margin-right: 20px;
}

.footer-links a:last-child {
    margin-right: 0;
}

.footer-contact-info p {
    margin: 8px 0;
    line-height: 1.6;
}

/* Responsive styles */
@media (max-width: 1024px) {
    .footer-content {
        flex-direction: column;
        gap: 40px;
    }

    .footer-right {
        text-align: left;
    }
}

@media (max-width: 768px) {
    .footer-container {
        padding: 30px 20px;
    }
    
    .footer-left {
        flex-direction: column;
        gap: 20px;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/Footer.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":["body {\n    margin: 0;\n    font-family: Arial, sans-serif;\n}\n\n.footer-container {\n    background-color: #222222;\n    color: #a9a9a9;\n    padding: 40px 60px;\n    font-size: 14px;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1430px;\n    margin: 0 auto;\n}\n\n.footer-left {\n    display: flex;\n    align-items: flex-start;\n}\n\n.footer-logo {\n    margin-right: 40px;\n}\n\n.footer-logo img {\n    height: 120px;\n}\n\n.footer-company-info .company-name {\n    color: #fff;\n    font-weight: bold;\n    font-size: 16px;\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n\n.footer-company-info p {\n    margin: 8px 0;\n    line-height: 1.6;\n}\n\n.footer-company-info .copyright {\n    margin-top: 30px;\n    color: #888;\n}\n\n.footer-right {\n    text-align: left;\n}\n\n.footer-links {\n    margin-bottom: 20px;\n}\n\n.footer-links a {\n    color: #fff;\n    font-weight: bold;\n    text-decoration: none;\n    font-size: 16px;\n    margin-right: 20px;\n}\n\n.footer-links a:last-child {\n    margin-right: 0;\n}\n\n.footer-contact-info p {\n    margin: 8px 0;\n    line-height: 1.6;\n}\n\n/* Responsive styles */\n@media (max-width: 1024px) {\n    .footer-content {\n        flex-direction: column;\n        gap: 40px;\n    }\n\n    .footer-right {\n        text-align: left;\n    }\n}\n\n@media (max-width: 768px) {\n    .footer-container {\n        padding: 30px 20px;\n    }\n    \n    .footer-left {\n        flex-direction: column;\n        gap: 20px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
